module.exports = __webpack_public_path__ + "img/bell-fill.5121b72d.svg";